module.exports = __webpack_public_path__ + "img/svm-result.0184a64f.jpeg";